import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-dynamic-datatask-goto',
  templateUrl: './dynamic-datatask-goto.component.html',
  styleUrls: ['./dynamic-datatask-goto.component.css']
})
export class DynamicDatataskGotoComponent implements OnInit {
    p2_datatask_keyno;

    public get?: DynamicDatataskGotoGet;
    //url: '/dynamicdatataskgoto/:p2_datatask_keyno',

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2_datatask_keyno = this.stateService.getStateParams()['p2_datatask_keyno'];
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3926, { p2_datatask_keyno: this.p2_datatask_keyno }))[0];

        //console.log('the get');
        //console.dir(this.get);

        if (!this.get) {
            this.stateService.back();
            return;
        }

        //Initial default values
        this.get.item_state ||= '';
        this.get.item_parms ||= '';

        if (this.get.item_state !== '') {
            this.stateService.go(this.get.item_state, this.get.item_parms === '' ? {} : this.get.item_parms);
        } else {
            this.stateService.back();
        }
    }

    async ngOnInit() {
        await this.loadGet();
    }
}

interface DynamicDatataskGotoGet {
    item_state: string;
    item_parms: string;
}
